<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-post-3-hormuzoilflow-box">
  <!-- Artboard: xs -->
  <div
    id="g-post-3-hormuzoilflow-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.73684210526316;"
  >
    <div
      id="g-post-3-hormuzoilflow-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-hormuzoilflow-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.7884%;margin-top:-18.5px;left:16.8277%;width:177px;"
    >
      <p class="g-pstyle0">Percentage of total oil flows</p>
      <p class="g-pstyle0">through the Strait of Hormuz</p>
      <p class="g-pstyle0">in the world maritime oil trade</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:26.5779%;margin-top:-7.5px;left:15.111%;width:45px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:26.5779%;margin-top:-7.5px;right:87.119%;width:49px;"
    >
      <p class="g-pstyle2">2020</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.2095%;margin-top:-7.5px;left:15.111%;width:45px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.2095%;margin-top:-7.5px;right:87.1006%;width:46px;"
    >
      <p class="g-pstyle2">2021</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:51.3148%;margin-top:-7.5px;left:15.111%;width:46px;"
    >
      <p class="g-pstyle1">29%</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:51.3148%;margin-top:-7.5px;right:87.1856%;width:48px;"
    >
      <p class="g-pstyle2">2022</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:63.42%;margin-top:-7.5px;left:15.111%;width:46px;"
    >
      <p class="g-pstyle1">28%</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:63.42%;margin-top:-7.5px;right:87.0983%;width:48px;"
    >
      <p class="g-pstyle2">2023</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:75.5253%;margin-top:-7.5px;left:15.111%;width:45px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:75.5253%;margin-top:-7.5px;right:87.211%;width:48px;"
    >
      <p class="g-pstyle2">2024</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.6306%;margin-top:-7.5px;left:15.111%;width:45px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:88.1569%;margin-top:-7.5px;right:86.9697%;width:64px;"
    >
      <p class="g-pstyle2">2025 Q1</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1042%;margin-top:-7.5px;left:14.1079%;margin-left:-19.5px;width:39px;"
    >
      <p class="g-pstyle3">0%</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1042%;margin-top:-7.5px;left:30.2174%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle3">20%</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1042%;margin-top:-7.5px;left:46.4838%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle3">40%</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1042%;margin-top:-7.5px;left:62.6496%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle3">60%</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1042%;margin-top:-7.5px;left:78.7931%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle3">80%</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1042%;margin-top:-7.5px;left:94.8833%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">100%</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-post-3-hormuzoilflow-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.82142857142857;"
  >
    <div
      id="g-post-3-hormuzoilflow-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-hormuzoilflow-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:5.9218%;margin-top:-14.6px;left:13.2202%;width:364px;"
    >
      <p class="g-pstyle0">
        Percentage of total oil flows through the Strait of Hormuz
      </p>
      <p class="g-pstyle0">in the world maritime oil trade</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.6718%;margin-top:-9.1px;left:11.402%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.6718%;margin-top:-9.1px;right:90.2107%;width:54px;"
    >
      <p class="g-pstyle2">2020</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.2432%;margin-top:-9.1px;left:11.402%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.2432%;margin-top:-9.1px;right:90.2951%;width:50px;"
    >
      <p class="g-pstyle2">2021</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.8147%;margin-top:-9.1px;left:11.402%;width:50px;"
    >
      <p class="g-pstyle1">29%</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.8147%;margin-top:-9.1px;right:90.2284%;width:53px;"
    >
      <p class="g-pstyle2">2022</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:60.3861%;margin-top:-9.1px;left:11.402%;width:50px;"
    >
      <p class="g-pstyle1">28%</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:60.3861%;margin-top:-9.1px;right:90.3586%;width:52px;"
    >
      <p class="g-pstyle2">2023</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:73.9575%;margin-top:-9.1px;left:11.402%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:73.9575%;margin-top:-9.1px;right:90.2476%;width:53px;"
    >
      <p class="g-pstyle2">2024</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.5289%;margin-top:-9.1px;left:11.402%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.5289%;margin-top:-9.1px;right:90.1961%;width:71px;"
    >
      <p class="g-pstyle2">2025 Q1</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1718%;margin-top:-9.1px;left:10.6767%;margin-left:-21px;width:42px;"
    >
      <p class="g-pstyle3">0%</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1718%;margin-top:-9.1px;left:27.7537%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle3">20%</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1718%;margin-top:-9.1px;left:44.9332%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">40%</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1718%;margin-top:-9.1px;left:62.0529%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">60%</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1718%;margin-top:-9.1px;left:79.1554%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">80%</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.1718%;margin-top:-9.1px;left:96.2506%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle3">100%</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-post-3-hormuzoilflow-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 2.53846153846154;"
  >
    <div
      id="g-post-3-hormuzoilflow-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-hormuzoilflow-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.8773%;margin-top:-9.1px;left:11.0645%;width:548px;"
    >
      <p class="g-pstyle0">
        Percentage of total oil flows through the Strait of Hormuz in the world
        maritime oil trade
      </p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.8773%;margin-top:-9.1px;left:9.1745%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.8773%;margin-top:-9.1px;right:92.5223%;width:54px;"
    >
      <p class="g-pstyle2">2020</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.4927%;margin-top:-9.1px;left:9.1745%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.4927%;margin-top:-9.1px;right:92.5874%;width:50px;"
    >
      <p class="g-pstyle2">2021</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.1081%;margin-top:-9.1px;left:9.1745%;width:50px;"
    >
      <p class="g-pstyle1">29%</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.1081%;margin-top:-9.1px;right:92.536%;width:53px;"
    >
      <p class="g-pstyle2">2022</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.7235%;margin-top:-9.1px;left:9.1745%;width:50px;"
    >
      <p class="g-pstyle1">28%</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.7235%;margin-top:-9.1px;right:92.6366%;width:52px;"
    >
      <p class="g-pstyle2">2023</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.3389%;margin-top:-9.1px;left:9.1745%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.3389%;margin-top:-9.1px;right:92.5509%;width:53px;"
    >
      <p class="g-pstyle2">2024</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:86.9543%;margin-top:-9.1px;left:9.1745%;width:49px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:86.9543%;margin-top:-9.1px;right:92.5111%;width:71px;"
    >
      <p class="g-pstyle2">2025 Q1</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.3389%;margin-top:-9.1px;left:8.4159%;margin-left:-21px;width:42px;"
    >
      <p class="g-pstyle3">0%</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.3389%;margin-top:-9.1px;left:26.1791%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle3">20%</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.3389%;margin-top:-9.1px;left:44.0212%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">40%</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.3389%;margin-top:-9.1px;left:61.8173%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">60%</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.3389%;margin-top:-9.1px;left:79.6006%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">80%</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.3389%;margin-top:-9.1px;left:97.3776%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle3">100%</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-post-3-hormuzoilflow-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 2.51351351351351;"
  >
    <div
      id="g-post-3-hormuzoilflow-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-hormuzoilflow-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.693%;margin-top:-8.7px;left:9.8049%;width:624px;"
    >
      <p class="g-pstyle0">
        Percentage of total oil flows through the Strait of Hormuz in the world
        maritime oil trade
      </p>
    </div>
    <div
      id="g-ai3-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.6929%;margin-top:-8.7px;left:7.8753%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.693%;margin-top:-8.7px;right:93.9311%;width:58px;"
    >
      <p class="g-pstyle2">2020</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.5578%;margin-top:-8.7px;left:7.8753%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.5578%;margin-top:-8.7px;right:93.9224%;width:54px;"
    >
      <p class="g-pstyle2">2021</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.1524%;margin-top:-8.7px;left:7.8753%;width:54px;"
    >
      <p class="g-pstyle1">29%</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.1524%;margin-top:-8.7px;right:93.9267%;width:57px;"
    >
      <p class="g-pstyle2">2022</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:58.0172%;margin-top:-8.7px;left:7.8753%;width:54px;"
    >
      <p class="g-pstyle1">28%</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:58.2876%;margin-top:-8.7px;right:93.8855%;width:57px;"
    >
      <p class="g-pstyle2">2023</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.8821%;margin-top:-8.7px;left:7.8753%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.8821%;margin-top:-8.7px;right:93.9389%;width:57px;"
    >
      <p class="g-pstyle2">2024</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.4768%;margin-top:-8.7px;left:7.8753%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.4767%;margin-top:-8.7px;right:93.968%;width:77px;"
    >
      <p class="g-pstyle2">2025 Q1</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.2064%;margin-top:-8.7px;left:7.1056%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle3">0%</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.2064%;margin-top:-8.7px;left:25.2489%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle3">20%</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.2064%;margin-top:-8.7px;left:43.4485%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">40%</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.2064%;margin-top:-8.7px;left:61.6184%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">60%</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.2064%;margin-top:-8.7px;left:79.778%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">80%</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.2064%;margin-top:-8.7px;left:97.948%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle3">100%</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-post-3-hormuzoilflow-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 3.24324324324324;"
  >
    <div
      id="g-post-3-hormuzoilflow-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-hormuzoilflow-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.8822%;margin-top:-8.7px;left:8.4085%;width:624px;"
    >
      <p class="g-pstyle0">
        Percentage of total oil flows through the Strait of Hormuz in the world
        maritime oil trade
      </p>
    </div>
    <div
      id="g-ai4-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.8821%;margin-top:-8.7px;left:6.446%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.8822%;margin-top:-8.7px;right:95.3047%;width:58px;"
    >
      <p class="g-pstyle2">2020</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:27.4767%;margin-top:-8.7px;left:6.446%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:27.4767%;margin-top:-8.7px;right:95.2979%;width:54px;"
    >
      <p class="g-pstyle2">2021</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:42.3416%;margin-top:-8.7px;left:6.446%;width:54px;"
    >
      <p class="g-pstyle1">29%</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:42.3416%;margin-top:-8.7px;right:95.3012%;width:57px;"
    >
      <p class="g-pstyle2">2022</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.2064%;margin-top:-8.7px;left:6.446%;width:54px;"
    >
      <p class="g-pstyle1">28%</p>
    </div>
    <div
      id="g-ai4-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.4768%;margin-top:-8.7px;right:95.2692%;width:57px;"
    >
      <p class="g-pstyle2">2023</p>
    </div>
    <div
      id="g-ai4-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:71.801%;margin-top:-8.7px;left:6.446%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai4-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:71.801%;margin-top:-8.7px;right:95.3107%;width:57px;"
    >
      <p class="g-pstyle2">2024</p>
    </div>
    <div
      id="g-ai4-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:86.666%;margin-top:-8.7px;left:6.446%;width:53px;"
    >
      <p class="g-pstyle1">27%</p>
    </div>
    <div
      id="g-ai4-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:86.6659%;margin-top:-8.7px;right:95.3333%;width:77px;"
    >
      <p class="g-pstyle2">2025 Q1</p>
    </div>
    <div
      id="g-ai4-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3956%;margin-top:-8.7px;left:5.6586%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle3">0%</p>
    </div>
    <div
      id="g-ai4-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3956%;margin-top:-8.7px;left:24.118%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle3">20%</p>
    </div>
    <div
      id="g-ai4-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3956%;margin-top:-8.7px;left:42.6209%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">40%</p>
    </div>
    <div
      id="g-ai4-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3956%;margin-top:-8.7px;left:61.1007%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">60%</p>
    </div>
    <div
      id="g-ai4-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3956%;margin-top:-8.7px;left:79.5728%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle3">80%</p>
    </div>
    <div
      id="g-ai4-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3956%;margin-top:-8.7px;left:98.0527%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle3">100%</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2026-03-02 15:29 -->

<!-- Generated by ai2html v0.101.0 - 2026-03-02 15:29 -->
<!-- ai file: post-3-hormuzoilflow.ai -->
<style lang="scss">
  #g-post-3-hormuzoilflow-box,
  #g-post-3-hormuzoilflow-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-3-hormuzoilflow-box p {
    margin: 0;
  }
  #g-post-3-hormuzoilflow-box .g-aiAbs {
    position: absolute;
  }
  #g-post-3-hormuzoilflow-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-3-hormuzoilflow-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-3-hormuzoilflow-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-3-hormuzoilflow-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-3-hormuzoilflow-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post-3-hormuzoilflow-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post-3-hormuzoilflow-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post-3-hormuzoilflow-xl {
        display: block !important;
      }
    }
  }
  #g-post-3-hormuzoilflow-xs {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-hormuzoilflow-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(149, 41, 120);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-hormuzoilflow-xs .g-pstyle0 {
    height: 12px;
  }
  #g-post-3-hormuzoilflow-xs .g-pstyle1 {
    font-weight: 900;
    line-height: 14px;
    height: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-3-hormuzoilflow-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-hormuzoilflow-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    text-align: center;
    color: rgb(166, 166, 166);
  }
  #g-post-3-hormuzoilflow-sm {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-hormuzoilflow-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(149, 41, 120);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-hormuzoilflow-sm .g-pstyle0 {
    height: 14px;
  }
  #g-post-3-hormuzoilflow-sm .g-pstyle1 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    color: rgb(255, 255, 255);
  }
  #g-post-3-hormuzoilflow-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-hormuzoilflow-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    text-align: center;
    color: rgb(166, 166, 166);
  }
  #g-post-3-hormuzoilflow-md {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-hormuzoilflow-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(149, 41, 120);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-hormuzoilflow-md .g-pstyle0 {
    height: 17px;
  }
  #g-post-3-hormuzoilflow-md .g-pstyle1 {
    font-weight: 900;
    height: 17px;
    color: rgb(255, 255, 255);
  }
  #g-post-3-hormuzoilflow-md .g-pstyle2 {
    font-weight: 400;
    height: 17px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-hormuzoilflow-md .g-pstyle3 {
    font-weight: 400;
    height: 17px;
    text-align: center;
    color: rgb(166, 166, 166);
  }
  #g-post-3-hormuzoilflow-lg {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-hormuzoilflow-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(149, 41, 120);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-hormuzoilflow-lg .g-pstyle0 {
    height: 16px;
  }
  #g-post-3-hormuzoilflow-lg .g-pstyle1 {
    font-weight: 900;
    height: 16px;
    color: rgb(255, 255, 255);
  }
  #g-post-3-hormuzoilflow-lg .g-pstyle2 {
    font-weight: 400;
    height: 16px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-hormuzoilflow-lg .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    text-align: center;
    color: rgb(166, 166, 166);
  }
  #g-post-3-hormuzoilflow-xl {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-hormuzoilflow-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(149, 41, 120);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-hormuzoilflow-xl .g-pstyle0 {
    height: 16px;
  }
  #g-post-3-hormuzoilflow-xl .g-pstyle1 {
    font-weight: 900;
    height: 16px;
    color: rgb(255, 255, 255);
  }
  #g-post-3-hormuzoilflow-xl .g-pstyle2 {
    font-weight: 400;
    height: 16px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-hormuzoilflow-xl .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    text-align: center;
    color: rgb(166, 166, 166);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
